export default "__VITE_ASSET__DgjiWAWD__"